import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import '../LeftNavigationBar/LeftNavigationBar.css';
import GeodataSvg from '../../assets/images/svgs/Geodata.svg?react';
import ArrowSvg from '../../assets/images/svgs/Arrow.svg?react';
import UserMgmtSvg from '../../assets/images/svgs/UserMgmt.svg?react';
import { updateLeftNavItem, toggleLeftNav } from "../../slices/leftNavSlice";
import { Tooltip } from "react-tooltip";
import { Routes } from "../../Routes";

const LeftNavigationBar = () => {

    const dispatch = useDispatch();
    const location = useLocation();
    const selectedLeftNavItem = location.pathname.split('/')[1];

    const isCollapsed = useSelector(state => state.leftNav.isCollapsed);

    const handleToggle = () => {
        dispatch(toggleLeftNav());
    };

    const handleItemClick = (item) => {
        dispatch(updateLeftNavItem(item));
    };

    return (
        <div className={`leftnav-section d-flex`}>
            <div id="leftnav" className={`${isCollapsed ? 'collapsed' : ''}`}>
                <div>
                    <Link to='/'
                        className="leftnav-item nav-header"
                        onClick={() => handleItemClick(selectedLeftNavItem)}>
                        <span className="nav-icon"><GeodataSvg /></span>
                        <span className="nav-label">Geodata</span>
                    </Link>
                    {Routes.map((item) => (
                        <Link
                            key={item.id}
                            to={item.path}
                            className={`leftnav-item ${selectedLeftNavItem === item.path.split('/')[1] ? 'active' : ''} ${item.className || ''}`}
                            onClick={() => handleItemClick(item.name)}
                            data-tooltip-id={`${item.tooltip}Id`}
                            data-tooltip-content={item.tooltip}
                            data-tooltip-place={item.place}
                        >
                            <span className="nav-icon">{item.icon}</span>
                            <span className="nav-label">{item.label}</span>
                        </Link>
                    ))}
                    {isCollapsed && Routes.map((item) => (
                        <Tooltip key={item.id} id={`${item.tooltip}Id`} />
                    ))}
                </div>
                <div>
                    <Link to='/profile'
                        className={`leftnav-item ${selectedLeftNavItem === 'profile' ? 'active' : ''}`}
                        onClick={() => handleItemClick(selectedLeftNavItem)}
                        data-tooltip-id="ProfileId"
                        data-tooltip-content="Profile"
                        data-tooltip-place="right-start"
                    >
                        <span className="nav-icon"><UserMgmtSvg /></span>
                        <span className="nav-label">Profile</span>
                    </Link>
                    {isCollapsed && <Tooltip id="ProfileId" />}
                </div>
            </div>
            <div className={`leftnav-action ${isCollapsed ? 'collapsed' : ''}`}>
                <button onClick={handleToggle} className="leftnav-toggle icon-button">
                    <ArrowSvg />
                </button>
            </div>
        </div>
    );
};

export default LeftNavigationBar;